export const IP = {
  globe:  "M12 2a10 10 0 110 20A10 10 0 0112 2zm0 0c-2.7 2.8-4 6.2-4 10s1.3 7.2 4 10m0-20c2.7 2.8 4 6.2 4 10s-1.3 7.2-4 10M2 12h20",
  car:    ["M5 17H3a1 1 0 01-1-1v-5l2.47-5.5A2 2 0 016.3 4h11.4a2 2 0 011.83 1.5L22 11v5a1 1 0 01-1 1h-2","M7.5 17a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm9 0a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"],
  credit: ["M22 9H2","M2 7a2 2 0 012-2h16a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V7z"],
  chart:  ["M18 20V10","M12 20V4","M6 20v-6"],
  shield: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z",
  pdf:    ["M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z","M14 2v6h6","M16 13H8m8 4H8m2-8H8"],
  users:  ["M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2","M9 11a4 4 0 100-8 4 4 0 000 8","M23 21v-2a4 4 0 00-3-3.87","M16 3.13a4 4 0 010 7.75"],
  tag:    ["M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z","M7 7h.01"],
  cal:    ["M8 2v4m8-4v4M3 10h18","M21 8H3a2 2 0 00-2 2v10a2 2 0 002 2h18a2 2 0 002-2V10a2 2 0 00-2-2z"],
  lock:   ["M19 11H5a2 2 0 00-2 2v7a2 2 0 002 2h14a2 2 0 002-2v-7a2 2 0 00-2-2z","M17 11V7a5 5 0 00-10 0v4"],
  bell:   ["M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9","M13.73 21a2 2 0 01-3.46 0"],
  zap:    "M13 2L3 14h9l-1 8 10-12h-9l1-8z",
  arrow:  "M5 12h14M12 5l7 7-7 7",
  star:   "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z",
  close:  "M18 6L6 18M6 6l12 12",
  check:  "M20 6L9 17l-5-5",
  clock:  ["M12 8v4l3 3", "M12 22a10 10 0 100-20 10 10 0 000 20z"],
};

/** SVG icon component */
export const Ic = ({ n, s = 20 }) => {
  const d = IP[n];
  return (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      {Array.isArray(d) ? d.map((p, i) => <path key={i} d={p} />) : <path d={d} />}
    </svg>
  );
};

/** Table cell value renderer */
export const CellVal = ({ v }) => {
  if (v === true)  return <span className="tg">✓</span>;
  if (v === false) return <span className="tx">—</span>;
  return <span style={{ fontSize:".81rem", color:"var(--muted)" }}>{v}</span>;
};
